import { useEffect } from 'react';
import { useIntentBehavior, useOverlayContext, useStateInRef } from 'seagull';
import { bulkCreateDraftsInterestTextsPath } from '~/components/BulkCreateDraftsInterestModal/BulkCreateDraftsInterestModal.utils';
import { useOpenBulkCreateDrafts } from '~/components/BulkCreateDraftsWizard/hooks/useOpenBulkCreateDrafts';
import { useStore } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useStateFromUrl } from '~/hooks/useStateFromUrl';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import { useRootDevice } from '~/providers/DeviceProvider';
import { selectors } from '~/store/state-selectors';
import { isBulkCreateDraftsArrivalValue, REQUEST_ACCESS_PARAM } from '~/utils/requestAccessLink';
export const useRequestAccessArrival = (param)=>{
    let { enabled, memberToastTestId, discardErrorToastTestId } = param;
    const { t } = useLocaleKeys(bulkCreateDraftsInterestTextsPath);
    const { urlState, changeUrlState } = useStateFromUrl({
        [REQUEST_ACCESS_PARAM]: {
            defaultValue: ''
        }
    });
    const { BULK_CREATE_PROPOSALS } = useFeatureFlags();
    const { getDisabled } = useIntentBehavior();
    const { isMobileDevice } = useRootDevice();
    const isPermittedToBulkCreate = useStore(selectors.user.isPermittedTo('BULK_CREATE_DRAFTS'));
    const { showInfoToast } = useOverlayContext();
    const { openBulkCreateDrafts } = useOpenBulkCreateDrafts({
        discardErrorToastTestId
    });
    const arrived = enabled && !!BULK_CREATE_PROPOSALS && isBulkCreateDraftsArrivalValue(urlState[REQUEST_ACCESS_PARAM]);
    const getWelcomeArrival = useStateInRef(welcomeArrival);
    useEffect(()=>{
        if (!arrived) {
            return;
        }
        changeUrlState({
            [REQUEST_ACCESS_PARAM]: ''
        });
        getWelcomeArrival()();
    }, [
        arrived
    ]);
    function welcomeArrival() {
        if (getDisabled(Intent.BulkCreateDrafts)) {
            showInfoToast(t.memberArrivalToast(), memberToastTestId);
            return;
        }
        // WHY: the wizard is desktop only, like the in-app entry points that open it
        if (isPermittedToBulkCreate && isMobileDevice) {
            return;
        }
        void openBulkCreateDrafts();
    }
};
